import { render, staticRenderFns } from "./UserCommunications.vue?vue&type=template&id=1bb42af8&scoped=true&"
import script from "./UserCommunications.vue?vue&type=script&lang=js&"
export * from "./UserCommunications.vue?vue&type=script&lang=js&"
import style0 from "./UserCommunications.vue?vue&type=style&index=0&id=1bb42af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb42af8",
  null
  
)

export default component.exports